// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { globalEnvironment } from './environment.global';

const apiBaseUrl = '';

export const environment = {
  production: false,
  ...globalEnvironment,
  apiUrl: {
    adminService: `${apiBaseUrl}/admin-service`,
    commonService: `${apiBaseUrl}/common-service`,
    communityService: `${apiBaseUrl}/community-service`,
    jobService: `${apiBaseUrl}/job-service`,
    notificationService: `${apiBaseUrl}/notification-service`,
    userService: `${apiBaseUrl}/user-service`,
  },
  firebase: {
    apiKey: 'AIzaSyAPH-xRpz3YLGVj0fPNg_zYPlg8G6LAjKQ',
    authDomain: 'development-7c695.firebaseapp.com',
    databaseURL: 'https://development-7c695.firebaseio.com',
    projectId: 'development-7c695',
    storageBucket: 'development-7c695.appspot.com',
    messagingSenderId: '403645165435',
    appId: '1:403645165435:web:87d870c2d7a5aeb9fc57de',
  },
  recaptcha: {
    siteKey: '6LfkqhoqAAAAAHMgM8j7nBFfEyZ4RhcM1tLm5F02',
  },
  gaTag: 'G-1XR219ZDEN',
  analyticsUrl: 'https://analytics.questalliance.net/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
